import { useNavigate } from "react-router-dom";
import { buildClasses } from "../utils/buildClasses";

export function Footer() {
  const navigate = useNavigate();

  return (
    <footer className={buildClasses("w-full", "py-16")}>
      <div
        className={buildClasses(
          "mx-auto",
          "flex",
          "w-[92%]",
          "max-w-[1344px]",
          "flex-col",
          "items-center",
          "gap-4",
          "text-on-surface-400",
        )}
      >
        <button
          className={buildClasses(
            "font-medium",
            "transition-colors",
            "hover:text-purple",
          )}
          onClick={() => navigate("/privacy")}
        >
          Privacy Policy
        </button>
        <div className={buildClasses("font-medium")}>
          Copyright &copy; 2026 Tappen LLC
        </div>
      </div>
    </footer>
  );
}
